import { useEffect, useState } from 'react';

function useGetAllSearchURLParams(urlParam: string) {
    const search = window.location.search;
    const [allSearchParams, setURLSearchParams] = useState(new URLSearchParams(search));

    useEffect(() => {
        setURLSearchParams(new URLSearchParams(search));
    }, [search]);

    const getSpecificValue: string = allSearchParams?.get(urlParam) || '';
    const checkSpecificValueExist: boolean = allSearchParams?.has(urlParam) || false;
    const allSearchParamsList: [string, string][] = [...allSearchParams?.entries()] || [];
    const allSearchParamsKeys: IterableIterator<string> = allSearchParams?.keys() || [];
    const allSearchParamsValues: IterableIterator<string> = allSearchParams?.values() || [];
    return {
        getSpecificValue, checkSpecificValueExist, allSearchParamsList, allSearchParamsKeys, allSearchParamsValues
    };
}

export default useGetAllSearchURLParams;
